import Crud from '../components/Analisis/Crud'
import Analisis from '../components/Analisis/Analisis'

let routes = {
    path: '/analisis',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/analisis',
          name: 'Análise',
          component: Crud
      },
      {
        path: '/analyse/:id?',
        name: 'Análise',
        component: Analisis
    },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/analisis.js